// eslint-disable-next-line import/prefer-default-export
export const getOrderedKeys = (incomingData) => {
  const priority = ["operator", "game"];
  return Object.keys(incomingData).sort((a, b) => {
    const aIndex = priority.indexOf(a);
    const bIndex = priority.indexOf(b);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
};
